import { Controller } from "@hotwired/stimulus"

// Loads a large embedded medical-record image on demand. The image's real URL
// lives in data-src (not src), so the browser doesn't fetch it until the coder
// clicks "Show image". See CodersHelper#deferred_note_image_html.
export default class extends Controller {
  static targets = ["button", "image"]

  show() {
    if (this.hasImageTarget) {
      this.imageTarget.src = this.imageTarget.dataset.src
      this.imageTarget.classList.remove("hidden")
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add("hidden")
    }
  }
}
